<header class="site_header" [ngClass]="{ scrolled: isScrolled }">
  <div class="container">
    <nav>
      <!-- (click)="drawer = true" -->
      <button
        (click)="openDrawer()"
        class="layout-menu-button layout-topbar-action"
      >
        <i class="pi pi-bars"></i>
      </button>
      <figure class="site_logo" [routerLink]="logoLink">
        <img [src]="assetsConst.logo" alt="Logo" />
      </figure>

      <form class="form" routerLink="/search-result"></form>

      <ul class="site_menu">
        @if (_userType === 'student' ) {
        <li
          routerLink="/student-dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        <li
          routerLink="/browse-mcq"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Browse
        </li>
        } @if (_userType === 'business-member') {
        <li
          routerLink="/student-dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        } @if (_userType === 'business') {
        <li
          routerLink="/business/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        <li
          routerLink="/browse-mcq"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Browse
        </li>
        <li
          (click)="uploadMenu.toggle($event)"
          role="button"
          tabindex="2"
          (keydown)="handleKeyDown($event, 'uploadMenu')"
        >
          + Member
        </li>
        <li
          (click)="selectmcqset()"
          role="button"
          tabindex="3"
          (keydown)="handleKeyDown($event, 'selectmcqset')"
        >
          Assign Seats
        </li>

        } @if (_userType === 'tutor') {
        <li
          routerLink="/tutor/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        <li
          (click)="newmcqset()"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="button"
          tabindex="4"
          (keydown)="handleKeyDown($event, 'newmcqset')"
        >
          + MCQ Exam/Set
        </li>
        }
      </ul>

      <ul class="action_menu">
        <ng-container
          *ngIf="_userType === 'business' || _userType === 'student'"
        >
<p-overlayBadge [value]="savedItemsCount()">
  <li
    class="cursor-pointer"
    routerLink="/saved-items"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <img src="{{ assetsConst.bookmarkIcon }}" alt="icon" />
  </li>
</p-overlayBadge>

          <li class="cursor-pointer" routerLink="/my-cart">
            <img src="{{ assetsConst.cartIcon }}" alt="icon" />
          </li>
        </ng-container>
        <li class="cursor-pointer" routerLink="/notifications">
          <img src="{{ assetsConst.notificationIcon }}" alt="icon" />
        </li>

        <li>
          <p-button (click)="menu.toggle($event)">
            <img [src]="assetsConst.barIcon" alt="Icon" />
            <span>Hi, {{ profile()?.fullName }}</span>
            <figure><img [src]="profile()?.image" alt="Icon" /></figure>
          </p-button>
        </li>
      </ul>
    </nav>
    <div class="sub_mobile_header">
      <ul class="site_menu">
        @if (_userType === 'student' ) {
        <li
          routerLink="/student-dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        <li
          routerLink="/browse-mcq"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Browse
        </li>
        } @if (_userType === 'business-member') {
        <li
          routerLink="/student-dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        } @if (_userType === 'business') {
        <li
          routerLink="/business/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        <li
          routerLink="/browse-mcq"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Browse
        </li>
        <li
          (click)="uploadMenu.toggle($event)"
          role="button"
          tabindex="2"
          (keydown)="handleKeyDown($event, 'uploadMenu')"
        >
          + Member
        </li>
        <li
          (click)="selectmcqset()"
          role="button"
          tabindex="3"
          (keydown)="handleKeyDown($event, 'selectmcqset')"
        >
          Assign Seats
        </li>

        } @if (_userType === 'tutor') {
        <li
          routerLink="/tutor/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Dashboard
        </li>
        <li
          (click)="newmcqset()"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="button"
          tabindex="4"
          (keydown)="handleKeyDown($event, 'newmcqset')"
        >
          + MCQ Exam/Set
        </li>
        }
      </ul>
        <ul class="action_menu">
        <ng-container
          *ngIf="_userType === 'business' || _userType === 'student'"
        >
          <li
            class="cursor-pointer"
            routerLink="/saved-items"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img src="{{ assetsConst.bookmarkIcon }}" alt="icon" />
          </li>
          <li class="cursor-pointer" routerLink="/my-cart">
            <img src="{{ assetsConst.cartIcon }}" alt="icon" />
          </li>
        </ng-container>
        <li class="cursor-pointer" routerLink="/notifications">
          <img src="{{ assetsConst.notificationIcon }}" alt="icon" />
        </li>

    
      </ul>
    </div>
  </div>
</header>

<p-menu
  #menu
  [model]="menuItems"
  [popup]="true"
  appendTo="body"
  class="common_menu"
>
  <ng-template pTemplate="item" let-item>
    <a
      *ngIf="item.path && !item.command"
      [routerLink]="item.path"
      class="header_menu p-menuitem-link"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <img [src]="item.icon" alt="{{ item.label }}" />
      <span>{{ item.label }}</span>
    </a>
    <a
      *ngIf="item.command"
      (click)="item.command()"
      (keydown.enter)="item.command()"
      (keydown.space)="item.command()"
      class="header_menu p-menuitem-link logout-item"
      style="cursor: pointer"
      tabindex="0"
      role="button"
      [attr.aria-label]="item.label"
    >
      <img [src]="item.icon" alt="{{ item.label }}" />
      <span>{{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>

<p-menu
  #uploadMenu
  [model]="uploadMenuItems"
  [popup]="true"
  appendTo="body"
  class="header_menu"
>


  <ng-template let-item pTemplate="item">
    <div class="common_menu upload_menu">
      <div class="s_head mb_10 hd_6 flex">
        <h2>Upload Method</h2>
      </div>
      <ul class="upload_list">
        <li
          (click)="addEmployee()"
          role="button"
          tabindex="0"
          (keydown)="handleKeyDown($event, 'addEmployee')"
        >
          <figure>
            <img src="{{ assetsConst.cvIcon }}" alt="" />
          </figure>
          <p>Bulk Upload</p>
        </li>
        <li
          role="button"
          tabindex="1"
          (keydown)="handleKeyDown($event, 'addBulEmployee')"
          (click)="addBulEmployee()"
        >
          <figure>
            <img src="{{ assetsConst.addUserIcon }}" alt="" />
          </figure>
          <p>Add Manually</p>
        </li>
      </ul>
    </div>
  </ng-template>
</p-menu>

<!-- responsive drawer -->
<!-- responsive drawer -->
<p-drawer
  *ngIf="isMobile"
  class="header_drawer"
  header="Menu List"
  [(visible)]="drawer"
  position="left"
>
  <div class="responsive_sidebar">
    <!-- Add [isMobileSidebar]="true" here -->
    <notchmark-common-layout
      [isMobileSidebar]="true"
      (menuSelected)="closeDrawer($event)"
    />
  </div>
</p-drawer>

<!-- responsive drawer end -->
